import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const CurrencyContext = createContext({
    ccurrency: "USD",
    rate: 1,
    baseCurrency: "SAR",
    setCurrency: () => { },
    setBaseCurrency: () => { },
    setRate: () => { },   // ✅ yeh add karo
});

export const CurrencyProvider = ({ children }) => {
    const [currency, setCurrency] = useState("USD");
    const [rate, setRate] = useState(1);
    const [baseCurrency, setBaseCurrency] = useState("USD");

    useEffect(() => {
        const fetchRate = async () => {
            try {
                if (currency === baseCurrency) {
                    setRate(1);
                    return;
                }

                const res = await axios.get(`https://open.er-api.com/v6/latest/${baseCurrency}`);
                if (res.data && res.data.rates && res.data.rates[currency]) {
                    setRate(res.data.rates[currency]);
                    console.log(`Rate from ${baseCurrency} to ${currency}: ${res.data.rates[currency]}`);
                } else {
                    console.error(`Rate not found for currency: ${currency}`);
                    setRate(1);
                }
            } catch (error) {
                console.error("Error fetching exchange rate:", error);
                setRate(1);
            }
        };

        fetchRate();
    }, [currency, baseCurrency]);

    return (
        <CurrencyContext.Provider value={{ currency, rate, baseCurrency, setCurrency, setBaseCurrency, setRate }}>
            {children}
        </CurrencyContext.Provider>
    );
};

export const useCurrency = () => useContext(CurrencyContext);
